import { render, staticRenderFns } from "./MaterialReviewTable.vue?vue&type=template&id=4745541b&"
import script from "./MaterialReviewTable.vue?vue&type=script&lang=js&"
export * from "./MaterialReviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4745541b')) {
      api.createRecord('4745541b', component.options)
    } else {
      api.reload('4745541b', component.options)
    }
    module.hot.accept("./MaterialReviewTable.vue?vue&type=template&id=4745541b&", function () {
      api.rerender('4745541b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/MaterialReviewTable.vue"
export default component.exports